import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles

import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

import "./PhotographerBanner.css";

// import required modules
// import { Navigation } from "swiper";
import SwiperCore, { Pagination, Navigation } from "swiper";
SwiperCore.use([Pagination, Navigation]);
export default function PhotographerBanner(props) {
  return (
    <>
      <img
        // onContextMenu={(e) => {
        //   e.preventDefault();
        // }}
        src={props.displayImages}
        alt=""
      />
      {/* <Swiper className="mySwiper">
        <SwiperSlide>
          <img
            onContextMenu={(e) => {
              e.preventDefault();
            }}
            src={props.displayImages}
            alt=""
          />
        </SwiperSlide> */}
        {/* <SwiperSlide><img onContextMenu={(e)=>{e.preventDefault()}} src={props.displayImages[1]} alt="" /></SwiperSlide>
                <SwiperSlide><img onContextMenu={(e)=>{e.preventDefault()}} src={props.displayImages[2]} alt="" /></SwiperSlide> */}
      {/* </Swiper> */}
    </>
  );
}
